// extracted by mini-css-extract-plugin
export default {"neutralBadge":"OperationRow_neutralBadge__kDHb-"};